import styled, { css } from 'styled-components'
import { FlatButton } from '@sketch/components'
import { ReactComponent as CanvasPageSvg } from '@sketch/icons/canvas-17'
import { ReactComponent as PrototypeSvg } from '@sketch/icons/prototype-17'
import { ReactComponent as PlaySquareSvg } from '@sketch/icons/play-square-17'

export const ListContainer = styled.div`
  max-height: 379px;
  overflow-y: auto;
  margin-left: 20px;
`

const iconStyles = css`
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  width: 17px;
  height: 17px;
  flex: none;
  margin-right: 4px;
`

export const PageIcon = styled(CanvasPageSvg)`
  ${iconStyles}
`

export const AllPrototypesIcon = styled(PrototypeSvg)`
  ${iconStyles}
`

export const PrototypeIcon = styled(PlaySquareSvg)`
  ${iconStyles}
`

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
  gap: 16px;
`

export const SearchActions = styled.div`
  display: flex;
`

export const SearchButton = styled(FlatButton)`
  padding: 4px 8px;
  text-decoration: underline;
`
